module.exports = __webpack_public_path__ + "static/media/mic.070f067c.ico";